// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class UserCasesResource extends Resource {
    basePath: string = 'cases/user/';

    objectPath: string = 'cases/user/{ident}/';
}
